export enum ProjectListOrderByColumnEnum {
    CREATED_OR_UPDATED_BY_PARTNER = 'CREATED_OR_UPDATED_BY_PARTNER',
    QUOTE_CLOSING_DATE = 'QUOTE_CLOSING_DATE',
    ABSTRACT_INDUSTRY_SECTOR = 'ABSTRACT_INDUSTRY_SECTOR',
    REQUESTED_PRODUCTS_TOTAL_COUNT = 'REQUESTED_PRODUCTS_TOTAL_COUNT',
    DISTRIBUTOR_NAME = 'DISTRIBUTOR_NAME',
    STATUS = 'STATUS',
    NAME = 'NAME',
    COMPANY_ZIP = 'COMPANY_ZIP',
    ROLLOUT_START = 'ROLLOUT_START',
    LAST_UPDATE_BY = 'LAST_UPDATE_BY',
    VALIDITY_OF_QUOTATION = 'VALIDITY_OF_QUOTATION',
    KAM = 'KAM',
    MAX_CONDITION = 'MAX_CONDITION',
    PRICE_APPROVAL_STATUS = 'PRICE_APPROVAL_STATUS',
}
